import { useNavigate } from "react-router-dom";

export function WelcomeRunner() {
  const navigate = useNavigate();

  const handleClose = () => {
    navigate("/profile-success");
  };

  const handleFindChallenge = () => {
    navigate("/");
  };

  return (
    <div className="min-h-screen bg-[#102210] relative overflow-hidden">
      {/* Background Atmospheric Effects */}
      <div className="absolute top-0 left-0 w-full h-[50%] bg-gradient-to-b from-primary/10 to-transparent pointer-events-none" />
      <div className="absolute -top-20 -right-20 w-64 h-64 bg-primary/20 rounded-full blur-[100px] pointer-events-none" />

      {/* Content */}
      <div className="relative z-10 flex flex-col min-h-screen max-w-md mx-auto">
        {/* Header */}
        <div className="flex items-center justify-between p-4">
          <button
            onClick={handleClose}
            className="p-2 rounded-full text-gray-400 hover:bg-white/5 transition-colors"
          >
            <span className="material-symbols-outlined text-2xl">close</span>
          </button>
          <span className="text-xs font-bold uppercase tracking-widest text-primary">
            Welcome
          </span>
          <div className="w-10" /> {/* Spacer for centering */}
        </div>

        {/* Hero Section */}
        <div className="flex-1 flex flex-col items-center justify-center py-8 px-6 gap-8 text-center">
          {/* Hero Icon with Glow & Orbit */}
          <div className="relative flex items-center justify-center">
            {/* Pulsing glow circle */}
            <div className="w-32 h-32 rounded-full bg-gradient-to-br from-[#1a2e1a] to-[#0c160c] border border-primary/20 flex items-center justify-center animate-pulse-glow">
              <span
                className="text-[64px] leading-none"
                style={{
                  filter: "drop-shadow(0 0 15px rgba(13, 242, 13, 0.4))",
                }}
              >
                👟
              </span>
            </div>
            {/* Orbiting dashed ring */}
            <div className="absolute w-40 h-40 rounded-full border border-dashed border-primary/10 animate-spin-slow" />
          </div>

          {/* Title */}
          <div className="flex flex-col gap-3">
            <h1 className="text-3xl font-extrabold text-white leading-tight tracking-tight">
              Start Your <br />
              <span className="text-primary">Running Journey</span>
            </h1>
          </div>

          {/* Description */}
          <p className="text-gray-400 text-base leading-relaxed max-w-[280px]">
            Create or Join a beginner-friendly challenge to kickstart your
            running habit.
          </p>
        </div>

        {/* Bottom Section */}
        <div className="mt-auto px-6 pb-8">
          {/* Recommendation Card */}
          <button
            onClick={handleFindChallenge}
            className="relative w-full overflow-hidden rounded-3xl bg-[#152015] border border-white/5 p-5 text-left group hover:border-primary/30 transition-all duration-300 mb-10"
          >
            {/* Card gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-primary/5 via-transparent to-transparent opacity-50" />

            <div className="relative z-10 flex items-center gap-4">
              <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-primary/20 flex items-center justify-center text-2xl">
                🌱
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-1.5">
                  <span className="text-primary text-xs font-semibold tracking-wide uppercase">
                    Recommended for you
                  </span>
                </div>
                <p className="text-white text-base font-bold leading-tight mt-1">
                  Start with a 1-2km daily goal
                </p>
              </div>
              <span className="material-symbols-outlined text-gray-400 group-hover:text-primary transition-colors">
                chevron_right
              </span>
            </div>
          </button>

          {/* CTA Button */}
          <button
            onClick={handleFindChallenge}
            className="relative w-full overflow-hidden rounded-full bg-primary h-14 group shadow-[0_0_20px_rgba(13,242,13,0.3)] hover:shadow-[0_0_30px_rgba(13,242,13,0.5)] transition-all duration-300"
          >
            {/* Hover overlay */}
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out rounded-full" />
            <div className="relative flex items-center justify-center gap-2 text-[#102210] text-lg font-bold tracking-wide">
              <span>Find a Beginner Challenge</span>
              <span className="material-symbols-outlined text-xl font-bold">
                arrow_forward
              </span>
            </div>
          </button>
        </div>
      </div>

      {/* Keyframe styles */}
      <style>{`
        @keyframes pulse-glow {
          0%, 100% { box-shadow: 0 0 20px 0px rgba(13, 242, 13, 0.1); }
          50% { box-shadow: 0 0 40px 10px rgba(13, 242, 13, 0.25); }
        }
        .animate-pulse-glow {
          animation: pulse-glow 3s infinite ease-in-out;
        }
        .animate-spin-slow {
          animation: spin 10s linear infinite;
        }
      `}</style>
    </div>
  );
}
